import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
    // FORCE DARK MODE - Always return 'dark'
    const [theme] = useState('dark');
    
    useEffect(() => {
        const root = window.document.documentElement;
        
        // Force dark theme
        root.classList.remove('light');
        root.classList.add('dark');
        
        // Force dark in localStorage
        localStorage.setItem('theme', 'dark');
        
        // Add to body for additional styling
        document.body.classList.add('dark');
        document.body.style.backgroundColor = '#0f172a'; // slate-900
    }, []);
    
    // No-op toggleTheme - keeps dark mode
    const toggleTheme = () => {
        // Do nothing - dark mode is permanent
        console.log('Theme toggle disabled - ZuperBooks uses dark mode only');
    };
    
    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}

export function useTheme() {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within ThemeProvider');
    }
    return context;
}
